import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { TimeSeriesSkeleton } from 'app/shared/skeleton';
import { PillToggle } from 'app/shared/pill-toggle';
import styles from './series.module.css';

export const TimeSeriesChart = ({
  className = '',
  innerClassName = '',
  data = [],
  graph_title = 'Graph title',
  key_filters = [],
  x_axis_key = 'day',
  is_loading_data = true,
  onDateRangeChange = () => {}
}) => {
  const [chart_data, setChartData] = useState([]);
  const [selected_range, setSelectedRange] = useState(7);

  useEffect(() => {
    handleDateRangeChange(7);
  }, []);

  useEffect(() => {
    setChartData(() => data);
  }, [data]);

  const range_options = [
    { label: '7 Days', value: 7 },
    { label: '15 Days', value: 15 },
    { label: '30 Days', value: 30 }
  ];

  const handleDateRangeChange = (value) => {
    if (!value) return;
    setSelectedRange(value);

    const today = new Date();
    const from_date = new Date(today.getTime() - value * 24 * 60 * 60 * 1000);

    onDateRangeChange([from_date.toISOString().split('T')[0], today.toISOString().split('T')[0]]);
  };

  return (
    <div className={cx(styles.wrapper, className)}>
      <header>
        <div className={styles.title}>{graph_title}</div>
        <PillToggle
          options={range_options}
          value={selected_range}
          onChange={handleDateRangeChange}
        />
      </header>
      <section className={cx(styles.chartSection, innerClassName)}>
        {is_loading_data ? (
          <TimeSeriesSkeleton />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={200}
              data={chart_data}
              margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 5
              }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey={x_axis_key} />
              <Tooltip />
              <Legend spacing={25} shapeRendering="circle" />
              {key_filters.map((selection) => (
                <Bar dataKey={selection.value} fill={selection.color} key={selection.value} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        )}
      </section>
    </div>
  );
};
